import React from 'react';
import invalidIcon from '../../../../../assets/images/Image_invalid.png';
import { Webhook } from '../../../../../assets/constant/webhookManager.type';
import ModalTemplateA from '../../../../../../legacy-common/template/modal/ModalTemplateA';
import BasicButton from '../../../../../components/_atom/button/BasicButton';
import { ButtonTheme } from '../../../../../components/_atom/button/StyledButton';
import { logic } from '../../../../../../logic';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

type DeleteWebhookModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  webhook?: Webhook;
};
const DeleteWebhookModal = (props: DeleteWebhookModalProps) => {
  const { isOpen, closeModal, webhook } = props;
  const navigate = useNavigate();
  const deleteWebhook = async () => {
    if (!webhook) {
      return;
    }
    const { error } = await logic.webhook.deleteSubscribeWebhook(webhook.subscription_id);
    if (error) {
      toast.error('Failed to delete webhook');
      return;
    }
    toast.success('Webhook deleted successfully');
    closeModal();
    navigate('/webhook');
  };
  return (
    <ModalTemplateA
      isOpen={isOpen}
      icon={invalidIcon}
      title={'Delete Webhook'}
      description={`Are you sure you want to delete the webhook "${webhook?.name}"?\nYou can't undo this action.`}
      showDivideLine={false}
      onRequestClose={closeModal}
      shouldCloseOnOverlayClick={false}
    >
      <div style={{ width: '100%', borderRadius: 12, padding: 14, background: '#EFEFEF', marginBottom: 40 }}>
        <div
          style={{
            fontWeight: 700,
            fontSize: 16,
            lineHeight: '24px',
          }}
        >
          Warning
        </div>
        <div
          style={{
            fontWeight: 400,
            fontSize: 14,
            lineHeight: '20px',
          }}
        >
          By deleting this webhook, you will stop receiving event notifications related to it.
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
        <BasicButton theme={ButtonTheme.NORMAL} onClick={closeModal}>
          Cancel
        </BasicButton>
        <BasicButton theme={ButtonTheme.MINOR} onClick={deleteWebhook}>
          Delete
        </BasicButton>
      </div>
    </ModalTemplateA>
  );
};

export default DeleteWebhookModal;
